"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconsReact = require("@carbon/icons-react");

require("./sass/CircularProgressBar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CircularProgressBar = function CircularProgressBar(props) {
  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      offset = _useState2[0],
      setOffset = _useState2[1];

  var circleRef = (0, _react.useRef)(null);
  var size = props.size,
      progress = props.progress,
      strokeWidth = props.strokeWidth,
      title = props.title,
      step = props.step;
  var center = size / 2;
  var radius = size / 2 - strokeWidth / 2;
  var circumference = 2 * Math.PI * radius;

  var checkActive = function checkActive() {
    var svgMain = Array.from(document.getElementsByTagName('svg'))[0];
    var iconDiv = document.getElementById('greencheck');

    if (progress !== 100) {
      svgMain.classList.add('not-active-empty');
    }

    if (progress === 100) {
      // if full instead of number, display a check
      svgMain.classList.add('hide-circle');
      iconDiv.children[0].classList.add('show-icon');
    }
  };

  (0, _react.useEffect)(function () {
    var progressOffset = (100 - progress) / 100 * circumference;
    setOffset(progressOffset);
    circleRef.current.style = 'transition: stroke-dashoffset 850ms ease-in-out';
    checkActive();
  }, [setOffset, progress, circumference, offset]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "circle-container"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "svg",
    width: size,
    height: size
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "svg-circle-bg",
    cx: center,
    cy: center,
    r: radius,
    strokeWidth: strokeWidth
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "svg-circle-inner",
    ref: circleRef,
    cx: center,
    cy: center,
    r: radius - 5,
    strokeWidth: strokeWidth,
    strokeDasharray: circumference,
    strokeDashoffset: offset
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "svg-circle",
    ref: circleRef,
    cx: center,
    cy: center,
    r: radius,
    strokeWidth: strokeWidth,
    strokeDasharray: circumference,
    strokeDashoffset: offset
  }), /*#__PURE__*/_react.default.createElement("text", {
    x: "".concat(center),
    y: "".concat(center + 5),
    className: "svg-circle-text"
  }, step)), /*#__PURE__*/_react.default.createElement("div", {
    id: "greencheck"
  }, /*#__PURE__*/_react.default.createElement(_iconsReact.CheckmarkFilled20, {
    className: "check-icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "tags-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "svg-circle-text-title"
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: "svg-circle-text-progress"
  }, progress, "% Completed")));
};

CircularProgressBar.propTypes = {
  size: _propTypes.default.number,
  progress: _propTypes.default.number,
  strokeWidth: _propTypes.default.number,
  title: _propTypes.default.string,
  step: _propTypes.default.number
};
var _default = CircularProgressBar;
exports.default = _default;